import cn from 'classnames';
import * as React from 'react';

import { MenuItem } from '@/types/menu';

import Chevron from './Chevron';
import styles from './styles.module.scss';

type Props = {
  item: MenuItem;
  isOpen: boolean;
  tabIndex?: number;
  ariaHidden?: boolean;
  onClick: () => void;
  onFocus?: () => void;
  nameClassName?: string;
};

const MenuItemButton: React.FC<Props> = ({
  item,
  isOpen,
  tabIndex,
  ariaHidden,
  onClick,
  onFocus,
  nameClassName = 'name'
}) => {
  return (
    <button
      className={cn({
        open: isOpen
      })}
      aria-expanded={isOpen}
      aria-haspopup={true}
      tabIndex={tabIndex}
      aria-hidden={ariaHidden}
      onClick={onClick}
      onFocus={onFocus}
    >
      {item.options.icon && <i className={cn('icon', item.options.icon.prefix, `fa-${item.options.icon.iconName}`)} />}
      <span className={cn(nameClassName)}>{item.name}</span>
      <span className={cn(styles.arrow, 'arrow')}>
        <Chevron className={cn(styles.chevron, 'chevron')} />
      </span>
    </button>
  );
};

export default MenuItemButton;
